import styled from "styled-components";

export const StyleWrapper = styled.div`
    ${'' /* background-color: cyan; */}
    min-height: inherit;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .review-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: white;
        width: 90%;
        margin: 20px 0px;
        border-radius: 10px;
        font-size: 16px;
        box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
    }
    .colored-box {
        border-top: 2px solid #C6222A;
        border-radius: 0px 0px 10px 10px;
        background-color: #FFFBFB;
        padding: 10px;
    }
    .review-row{
        display: flex;
        flex-direction: row;
        width: 100%;
        margin-left: inherit;
        margin-right: inherit;
        justify-content: space-between;
        color: #565F6B;
        ${'' /* background-color: red; */}
    }
    .flex-end {
        // justify-content: flex-end;
    }
    .review-title {
        padding: 5px 15px 0px 15px;
    }
    .review-value{
        padding: 5px 15px 0px 15px;
        font-weight: 600;
        font-size: 16px;
    }
    .insurance-checkbox {
        display: flex;
        align-items: center;
    }
    .insurance-field {
        padding: unset;
    }
    .colored-text {
        color: #C6222A;
        font-weight: 600;
        font-size: 18px;
    }
    .review-button {
        padding: 0px 15px;
        font-size: 12px;
        color: #C6222A;
        background-color: transparent;
        border: none;
    }
    .review-button:hover {
        text-decoration: underline;
    }


    .review-bottom-behind-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: normal;
        background-color: #FFFBFB;
        width: 90%;
        padding: 10px;
        border-radius: 10px;
        margin: 20px 0px;
        ${'' /* gap: 10px; */}
        font-size: 16px;
        flex-wrap: wrap;
        box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
    }

    .review-data-box{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-content: flex-start;
        align-items: normal;
        ${'' /* background-color: pink; */}
        border-radius: 10px;
        ${'' /* padding: 10px 10px 0px 10px; */}
        gap: 10px;
        row-gap: 10px;
        font-size: 16px;
        flex-wrap: wrap;
    }

    .review-block{
        ${'' /* background-color: rgba(255,0,0,0.3); */}
        min-width: 150px;
    }

    .review-block > * {
        padding: 0px 10px;
    }

    .review-block .title {
        padding-top: 0px;
    }
    .review-block .value {
        padding-top: 2px;
    }
    .review-message {
        font-size: 12px;
    }

    .review-bottom {
        justify-content: flex-end!important;
    }

    .bottomDiv {
        ${'' /* background-color: cyan; */}
        padding: 0 25px;
    }

`;
